<div class="asset-popup">
  <div class="asset-popup__heading">
    <div class="asset-popup__heading--image">
      @if (assetImage) {
        <div (click)="openImagePreview()">
          <img [src]="assetImage" />
        </div>
      }
    </div>
    <div class="asset-popup__heading--description">
      <b>{{ description }}</b>
    </div>
  </div>
  <div class="asset-popup__separator"></div>
  <div class="asset-popup__body">
    <div class="asset-popup__asset-info">
      <div class="info-heading-text">
        {{ 'AssetPopup.AssetOwner' | translate }}
      </div>
      <div class="info-body-text">
        <b>{{ userName || '-' }}</b>
      </div>
      <br />
      <div class="info-heading-text">
        {{ 'AssetPopup.Department' | translate }}
      </div>
      <div class="info-body-text">
        <b>{{ department || '-' }}</b>
      </div>
      <br />
      <div class="info-heading-text">
        {{ 'AssetPopup.CurrentLocation' | translate }}
      </div>
      <div class="info-body-text">
        <b>{{ currentLocation || '-' }}</b>
      </div>
      <br />
      <div class="info-heading-text">
        {{ 'AssetPopup.FindSerial' | translate }}
      </div>
      <div class="info-body-text">
        <b>{{ serial || '-' }}</b>
      </div>
      <br />
      <div class="info-heading-text">
        {{ 'AssetPopup.Temperature' | translate }}
      </div>
      <div class="info-body-text">
        <b>{{ temperature ? temperature + '°C' : '-' }}</b>
      </div>
      <br />
      <div class="info-heading-text">
        {{ 'AssetPopup.LastMoved' | translate }}
      </div>
      @if (lastMoved && lastMoved !== '-') {
        <div class="info-body-text">
          <b>{{ lastMoved | date: 'dd.MM.yyyy H:mm' }}</b>
        </div>
      }
    </div>
  </div>
  <div clas="asset-popup__last-activity">
    <div class="asset-popup__last-activity--mins">
      <b>
        {{ 'AssetPopup.LastActivity' | translate }}:
        @if (lastActivityTime) {
          <span>{{ lastActivityTime | dateAgo }}</span>
        }
      </b>
    </div>
  </div>
</div>
